import React from 'react'
import Home from '../Home/Home'
import About from '../About/About'
import Project from '../Projects/Project'
import Skill from '../Skills/Skill'



function HomePage() {
  return (
    <div>
      <Home/>
      <About/>
      <Project/>
    </div>
  )
}

export default HomePage